import { styled } from '@/stitches.config';
import { CSS } from '@stitches/react';
import { Box, Form } from '@base-app';

export const StyledForm = styled(Form, {
  margin: '0',
  marginBottom: '$8',
});

export const StyledSelectorsContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginBottom: '$8',
});

export const formFieldStyles: CSS = {
  width: '32%',
};

export const StyledTitle = styled('span', {
  alignSelf: 'flex-start',
  color: '$darkBlue300',
  fontSize: '$lg',
  fontWeight: '$bold',
  lineHeight: '$6',
  marginBottom: '$10',
});

export const sendButtonStyles: CSS = {
  margin: 'auto',
};
